<template>
  

  <NuxtLink :to="user.link" class="wrapper">


    <img loading="lazy" 
      v-if="user.avatar_little" 
      :src="user.avatar_little" 
      class="avatar"
      />



    <div class="body">
        {{ user.name }}
    </div>


  </NuxtLink>

</template>

<script setup lang="ts">
import type { NotificationUser } from '@/types/notification'

 
 const props = defineProps<{ user: NotificationUser }>()
 
 

</script>

<style scoped>

.wrapper{
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: fit-content;
}

.avatar{
  width: 22px;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
}

.body{
  flex: 1 1 auto;
  overflow: hidden;
  color: var(--un-text-color);
}

</style> 